<template>
  <header_m/>
  <News_index_m></News_index_m>
  <News_page_m></News_page_m>
  <br>
  <Footer_m/>
</template>

<script>
import News_index_m from "@/components/CN_mobile/news/News_index_m";
import News_page_m from "@/components/CN_mobile/news/News_page_m";
import Footer_m from "@/components/CN_mobile/Footer_m";
import Header_m from "@/components/CN_mobile/Header_m";
export default {
  name: 'News_m',
  components: {Header_m, Footer_m, News_page_m, News_index_m, },
}

</script>